import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import converterMoeda from '~js/converter-moeda';

Vue.use(VueResource);

function normalizarParaVisualizar(pedido) {

  var itens = [];

  for (var i = 0; i < pedido.itensPedidoCompra.length; i++) {
    if (pedido.itensPedidoCompra[i].quantidade > 0)
      itens.push(pedido.itensPedidoCompra[i])
  }

  pedido.itensPedidoCompra = itens;

  pedido.itensPedidoCompra.map(item => {
    item.quantidade = converterMoeda.paraReal(item.quantidade || 0);
    item.quantidadeCancelada = converterMoeda.paraReal(item.quantidadeCancelada || 0);
    item.valorUnitario = converterMoeda.paraReal(item.valorUnitario || 0);
    item.ipiItemPedido = converterMoeda.paraReal(item.ipiItemPedido || 0);
    item.descontoDinheiro = converterMoeda.paraReal(item.descontoDinheiro || 0);
  });

  pedido.dataVencimento = '';

  return pedido;
}

export default {
  lista: (filtros) => {
    const parametros = Object.assign({}, filtros);

    return Vue.http.get('/api/pedido/listaliberacao', { params: parametros }).then(response => response.data);
  },
  obterPorIdRelatorio: id => {
    return Vue.http.get(`/api/pedido/${id}`)
      .then(response => response.data)
      .then(pedido => normalizarParaVisualizar(pedido));
  },
  liberar: id => {
    return Vue.http.put(`/api/pedido/${id}/liberar`).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-pedidos-compras/servico.js